import React, { Component } from 'react'

import './Paginator.scss'

class Paginator extends Component {
    // if row length is updated to a smaller value resulting in the user being on a page that is too high:
    componentDidUpdate(prevProps) {
        let last_page_total =
            (prevProps.rowLength / prevProps.pageSize) % 1 !== 0 &&
            prevProps.rowLength > prevProps.pageSize
                ? Math.floor(prevProps.rowLength / prevProps.pageSize) + 1
                : Math.floor(prevProps.rowLength / prevProps.pageSize)
        let page_total =
            (prevProps.rowLength / prevProps.pageSize) % 1 !== 0 &&
            this.props.rowLength > this.props.pageSize
                ? Math.floor(this.props.rowLength / this.props.pageSize) + 1
                : Math.floor(this.props.rowLength / this.props.pageSize)

        if (last_page_total !== page_total && this.props.activePage > page_total) {
            this.props.paginateCallback(page_total || 1) // can never be 0
        }
    }

    changeActivePage = (right_clicked, page_total) => {
        if (right_clicked) {
            if (this.props.activePage + 1 > page_total) return null
            this.props.paginateCallback(this.props.activePage + 1)
        } else {
            if (this.props.activePage - 1 <= 0) return null
            this.props.paginateCallback(this.props.activePage - 1)
        }
    }

    render() {
        const { rowLength, paginateCallback, activePage, pageSize } = this.props

        let page_total =
            rowLength % pageSize !== 0 && rowLength > pageSize
                ? Math.floor(rowLength / pageSize) + 1
                : Math.floor(rowLength / pageSize)
        let offset_beginning = pageSize * activePage - pageSize + (rowLength === 0 ? 0 : 1)
        let offset_end = pageSize * activePage > rowLength ? rowLength : pageSize * activePage

        return (
            <div className="Paginator__cont">
                <div className="totals">
                    <span>
                        {offset_beginning}-{offset_end}
                    </span>{' '}
                    of {rowLength} results
                </div>

                {page_total !== 0 && (
                    <div className="paginator">
                        <div
                            className={`chevron left ${activePage !== 1 ? '' : 'inactive'}`}
                            onClick={
                                activePage !== 1
                                    ? () => this.changeActivePage(false, page_total)
                                    : () => {}
                            }
                        />

                        {activePage >= 5 && page_total !== 5 && (
                            <div className="inbetween" onClick={() => paginateCallback(1)}>
                                1 ...
                            </div>
                        )}

                        <div className="pages">
                            {[...Array(page_total)].map((_, i) => {
                                let page_number = i + 1
                                let inactive = false
                                let active_class = page_number === activePage ? 'active' : ''

                                if (activePage < page_number - 1 || activePage > page_number + 1) {
                                    inactive = true
                                }

                                if (
                                    (activePage < 5 && page_number <= 5) ||
                                    (activePage > page_total + 1 - 5 &&
                                        page_number >= page_total + 1 - 5)
                                ) {
                                    inactive = false
                                }

                                if (inactive) return ''

                                return (
                                    <div
                                        className={`page ${active_class}`}
                                        onClick={() => paginateCallback(page_number)}
                                        key={page_number}
                                    >
                                        <span>{page_number}</span>
                                    </div>
                                )
                            })}
                        </div>

                        {activePage >= 1 && activePage <= page_total + 1 - 5 && page_total !== 5 && (
                            <div className="inbetween" onClick={() => paginateCallback(page_total)}>
                                ... {page_total}
                            </div>
                        )}

                        <div
                            className={`chevron right ${
                                activePage !== page_total ? '' : 'inactive'
                            }`}
                            onClick={
                                activePage !== page_total
                                    ? () => this.changeActivePage(true, page_total)
                                    : () => {}
                            }
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default Paginator
